import React from 'react';
import { dataAction3 } from '../../assets/fake-data/data-action.js';

const Action3 = () => {

    return (
        <section className="tf-section career-action mb-60 pt-24">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="action__body_email" data-aos="fade-up">
                            <div className="block-text">
                                <h3 className="mb-13">{dataAction3.title}</h3>
                                <p className='fs-21 mb-7'> {dataAction3.desc} <a href="mailto:career@redstone.rs">career@redstone.rs</a></p>
                                <p className="fs-21 mb-7 it-1">{dataAction3.note}</p>
                            </div>
                            <a className="btn-action style-2" href="mailto:career@redstone.rs">{dataAction3.buttonText}</a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Action3;